module.exports = __webpack_public_path__ + "img/image-titan.106030f7.webp";